import { Injectable } from '@angular/core';
import axios from 'axios';
import { BASE_URL_SERVICIOS_CORESERVICE, environment, BASE_URL_SERVICIOS_BACK } from "@env/environment";
import { Router } from '@angular/router';
import { ToolsService } from '@services/varios/tools.service';
import { Funcionario } from 'src/app/common/interfaces/funcionario.model';
import { DatosPersonalesLite } from 'src/app/common/interfaces/datos-personales-lite.model';
import { AuthService } from '@services/auth/auth.service';

@Injectable({
	providedIn: 'root'
})

export class IntranetService {

	constructor(private readonly router: Router, private readonly toolsService: ToolsService, private readonly authService: AuthService) { }

	public async getFuncionarioByRut(rut: any) {
		let BASE_URL = BASE_URL_SERVICIOS_CORESERVICE + '/coreservice/intranet/getDatosFuncionarioByRut?rut=' + rut;

		return await axios.get(BASE_URL, {
			headers: {
				apiKey: environment.apiKeyIntranet,
			},
		}).then(resp => {
			if (resp.data != undefined) {
				return resp.data;
			} else {
				let rs: Funcionario = {} as Funcionario;
				return rs;
			}
		}).catch(async error => {

			if (error.response.status == 401) {
				sessionStorage.clear();
				await this.toolsService.errorSesionMensaje();
				this.router.navigate(['/']);
				return null;
			} else {
				let rs: Funcionario = {} as Funcionario;
				return rs;
			}
		});
	}

	public async getPeriodosFuncionarioByRut(rut: any) {
		let BASE_URL = BASE_URL_SERVICIOS_BACK + '/miperfilback/api/v1/findCsvPersona/' + rut;
		let UsrInfo = this.authService.getUserInfo();

		return await axios.get(BASE_URL, {
			headers: {
				Authorization: `Bearer ${UsrInfo.jwt}`,
			},
		}).then(resp => {
			if (resp.data != undefined) {
				return resp.data;
			} else {
				let rs: [] = [];
				return rs;
			}
		}).catch(async error => {

			if (error.response.status == 401) {
				sessionStorage.clear();
				await this.toolsService.errorSesionMensaje();
				this.router.navigate(['/']);
				return null;
			} else {
				let rs: [] = [];
				return rs;
			}
		});
	}

	public async getLiquidacion(datosFuncionarioLite: any) {
		let BASE_URL = BASE_URL_SERVICIOS_BACK + '/miperfilback/api/v1/getLiquidacion';
		let UsrInfo = this.authService.getUserInfo();

		return await axios.post(BASE_URL, datosFuncionarioLite, {
			headers: {
				Authorization: `Bearer ${UsrInfo.jwt}`,
			},
		})
			.then(async response => {
				if (response.data.mensaje != 'Ok') {
					await this.toolsService.errorMensaje("No se pudo generar Liquidación");
				} else {
					let contentTypes = '';
					if (response.data.extension == 'PDF') {
						contentTypes = 'application/pdf'
					} else if (response.data.extension == 'ZIP') {
						contentTypes = 'application/zip'
					}

					const byteCharacters = this.base64toBlob(response.data.contenidoBytes, contentTypes);
					const href = window.URL.createObjectURL(byteCharacters);
					const anchorElement = document.createElement('a');
					anchorElement.href = href;
					anchorElement.download = response.data.nombre;
					document.body.appendChild(anchorElement);
					anchorElement.click();
					document.body.removeChild(anchorElement);
					window.URL.revokeObjectURL(href);
					await this.toolsService.okMensaje("Liquidación generada exitosamente");
				}
			}).catch(async error => {
				if (error.response.status == 500) {
					await this.toolsService.errorMensaje("No se pudo generar Liquidación");
				}
			});
	}

	public async getCertificadoAntiguedad(datosFuncionarioLite: any) {
		let BASE_URL = BASE_URL_SERVICIOS_BACK + '/miperfilback/api/v1/getCertificadoAntiguedad';
		let UsrInfo = this.authService.getUserInfo();

		return await axios.post(BASE_URL, datosFuncionarioLite, {
			headers: {
				Authorization: `Bearer ${UsrInfo.jwt}`,
			},
		})
			.then(async response => {
				if (response.data.mensaje != 'Ok') {
					await this.toolsService.errorMensaje("No se pudo generar Certificado de Antigüedad.");
				} else {
					let contentTypes = '';
					if (response.data.extension == 'PDF') {
						contentTypes = 'application/pdf'
					} else if (response.data.extension == 'ZIP') {
						contentTypes = 'application/zip'
					}

					const byteCharacters = this.base64toBlob(response.data.contenidoBytes, contentTypes);
					const href = window.URL.createObjectURL(byteCharacters);
					const anchorElement = document.createElement('a');
					anchorElement.href = href;
					anchorElement.download = response.data.nombre;
					document.body.appendChild(anchorElement);
					anchorElement.click();
					document.body.removeChild(anchorElement);
					window.URL.revokeObjectURL(href);
					await this.toolsService.okMensaje("Certificado de Antigüedad generado exitosamente");
				}
			}).catch(async error => {
				if (error.response.status == 500) {
					await this.toolsService.errorMensaje("No se pudo generar Certificado de Antigüedad.");
				}
			});
	}

	public async getCertificadoSueldo(datosFuncionarioLite: any) {
		let BASE_URL = BASE_URL_SERVICIOS_BACK + '/miperfilback/api/v1/getCertificadoSueldo';
		let UsrInfo = this.authService.getUserInfo();

		return await axios.post(BASE_URL, datosFuncionarioLite, {
			headers: {
				Authorization: `Bearer ${UsrInfo.jwt}`,
			},
		})
			.then(async response => {
				if (response.data.mensaje != 'Ok') {
					await this.toolsService.errorMensaje("No se pudo generar Certificado de Sueldo.");
				} else {
					let contentTypes = '';
					if (response.data.extension == 'PDF') {
						contentTypes = 'application/pdf'
					} else if (response.data.extension == 'ZIP') {
						contentTypes = 'application/zip'
					}

					const byteCharacters = this.base64toBlob(response.data.contenidoBytes, contentTypes);
					const href = window.URL.createObjectURL(byteCharacters);
					const anchorElement = document.createElement('a');
					anchorElement.href = href;
					anchorElement.download = response.data.nombre;
					document.body.appendChild(anchorElement);
					anchorElement.click();
					document.body.removeChild(anchorElement);
					window.URL.revokeObjectURL(href);
					await this.toolsService.okMensaje("Certificado de Sueldo generado exitosamente");
				}
			}).catch(async error => {
				if (error.response.status == 500) {
					await this.toolsService.errorMensaje("No se pudo generar Certificado de Sueldo.");
				}
			});
	}

	public async getCertificadoRenta(datosFuncionarioLite: any) {
		let BASE_URL = BASE_URL_SERVICIOS_BACK + '/miperfilback/api/v1/getCertificadoRenta';
		let UsrInfo = this.authService.getUserInfo();

		return await axios.post(BASE_URL, datosFuncionarioLite, {
			headers: {
				Authorization: `Bearer ${UsrInfo.jwt}`,
			},
		})
			.then(async response => {
				if (response.data.mensaje != 'Ok') {
					await this.toolsService.errorMensaje("No se pudo generar Certificado de Renta.");
				} else {
					let contentTypes = '';
					if (response.data.extension == 'PDF') {
						contentTypes = 'application/pdf'
					} else if (response.data.extension == 'ZIP') {
						contentTypes = 'application/zip'
					}

					const byteCharacters = this.base64toBlob(response.data.contenidoBytes, contentTypes);
					const href = window.URL.createObjectURL(byteCharacters);
					const anchorElement = document.createElement('a');
					anchorElement.href = href;
					anchorElement.download = response.data.nombre;
					document.body.appendChild(anchorElement);
					anchorElement.click();
					document.body.removeChild(anchorElement);
					window.URL.revokeObjectURL(href);
					await this.toolsService.okMensaje("Certificado de Renta generado exitosamente");
				}
			}).catch(async error => {
				if (error.response.status == 500) {
					await this.toolsService.errorMensaje("No se pudo generar Certificado de Renta.");
				}
			});
	}

	base64toBlob(base64Data: string, contentType: string) {
		contentType = contentType || '';
		let sliceSize = 1024;
		let byteCharacters = atob(base64Data);
		let bytesLength = byteCharacters.length;
		let slicesCount = Math.ceil(bytesLength / sliceSize);
		let byteArrays = new Array(slicesCount);

		for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
			let begin = sliceIndex * sliceSize;
			let end = Math.min(begin + sliceSize, bytesLength);

			let bytes = new Array(end - begin);
			for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
				bytes[i] = byteCharacters[offset].charCodeAt(0);
			}
			byteArrays[sliceIndex] = new Uint8Array(bytes);
		}
		return new Blob(byteArrays, { type: contentType });
	}

	llenarFuncionarioLite(datosFuncionario: any): DatosPersonalesLite {
		let datosFuncionarioLite: DatosPersonalesLite = {} as DatosPersonalesLite;
		datosFuncionarioLite.corrFuncionario = datosFuncionario.corrFuncionario;
		datosFuncionarioLite.rut = datosFuncionario.rut;
		datosFuncionarioLite.numeroEmpleado = datosFuncionario.numeroEmpleado;
		datosFuncionarioLite.nombreCompleto = datosFuncionario.nombreCompleto;
		datosFuncionarioLite.unidad = datosFuncionario.unidad;
		datosFuncionarioLite.cargo = datosFuncionario.cargo;
		datosFuncionarioLite.fechaInicioCargo = datosFuncionario.fechaInicioCargo;
		datosFuncionarioLite.fechaCese = datosFuncionario.fechaCese;
		datosFuncionarioLite.tipoContrato = datosFuncionario.tipoContrato;
		datosFuncionarioLite.grado = datosFuncionario.grado;
		datosFuncionarioLite.estamento = datosFuncionario.estamento;
		datosFuncionarioLite.fechaIngreso = datosFuncionario.fechaIngreso;
		datosFuncionarioLite.nombreIsapre = datosFuncionario.nombreIsapre;
		datosFuncionarioLite.nombreAfp = datosFuncionario.nombreAfp;
		datosFuncionarioLite.nombreCajaCompensacion = datosFuncionario.nombreCajaCompensacion;
		datosFuncionarioLite.perSaldoPcgr = datosFuncionario.perSaldoPcgr;
		datosFuncionarioLite.perSaldoFeriadoLegal = datosFuncionario.perSaldoFeriadoLegal;
		datosFuncionarioLite.cantidadBienios = datosFuncionario.cantidadBienios;
		datosFuncionarioLite.estadoFuncionario = datosFuncionario.estadoFuncionario;
		datosFuncionarioLite.isHonorario = datosFuncionario.isHonorario;

		return datosFuncionarioLite;
	}
}